<template>
	<div :class="flexOptions" class="field is-horizontal is-flex-touch is-flex-wrap">
		<slot name="label">
			<label v-if="labelKey" v-t="labelKey" class="field-label" />
		</slot>
		<div class="field-body is-flex-grow">
			<div :class="groupingType" class="field is-grouped has-flex-align-center">
				<slot name="controls">
					<div :class="{ 'is-expanded': expanded }" class="control">
						<slot>{{ value }}</slot>
					</div>
				</slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DpField',
	props: {
		centered: { type: Boolean, default: false },
		labelKey: { type: String, default: null },
		value: { type: [String, Number], default: null },
		expanded: { type: Boolean, default: false },
		flexAlways: { type: Boolean, default: true },
	},
	computed: {
		flexOptions() {
			return this.centered ? 'has-flex-center' : 'has-flex-space-between';
		},
		groupingType() {
			return this.centered ? 'is-grouped-centered' : 'is-grouped-right';
		},
	},
};
</script>
